import { PROFILES } from '../../../common/constants/generic/types';

/**
 * Perfil da operacao INTERNA.
 *
 * Separa quem opera o sistema (Administrativo) de quem so o consome pela borda
 * — Corban e Cliente. Recursos que falam do sistema inteiro, e nao do dia a dia
 * de quem esta na borda, ficam so para ele.
 *
 * A comparacao e numerica de proposito: o perfil chega do storage como TEXTO.
 */
export function isAdministrativeProfile(user) {
  return Number(user?.profileId) === PROFILES.ADMINISTRATIVE.id;
}

export default { isAdministrativeProfile };
